import { useCallback, useEffect, useState } from 'react'

const SCROLL_DISTANCE = 200
const IS_SCROLLED_BUFFER = 5

const useScrolledElement = (element: HTMLElement | null) => {
	const [isScrolledLeft, setIsScrolledLeft] = useState(false)
	const [isScrolledRight, setIsScrolledRight] = useState(false)

	useEffect(() => {
		if (!element) return undefined

		const updateScrollState = () => {
			setIsScrolledLeft(element.scrollLeft > IS_SCROLLED_BUFFER)
			setIsScrolledRight(!(element.scrollLeft + element.clientWidth > element.scrollWidth - IS_SCROLLED_BUFFER))
		}

		updateScrollState()
		element.addEventListener('scroll', updateScrollState)

		const resizeObserver = new ResizeObserver(updateScrollState)
		resizeObserver.observe(element)

		// Content width growth (e.g. lazy-loaded items) may not resize the scroll container itself
		if (element.firstElementChild) {
			resizeObserver.observe(element.firstElementChild)
		}

		return () => {
			element.removeEventListener('scroll', updateScrollState)
			resizeObserver.disconnect()
		}
	}, [element])

	const scrollLeft = useCallback(() => element?.scrollBy(-SCROLL_DISTANCE, 0), [element])
	const scrollRight = useCallback(() => element?.scrollBy(SCROLL_DISTANCE, 0), [element])

	return { isScrolledLeft, isScrolledRight, scrollLeft, scrollRight } as const
}

export default useScrolledElement
